import { render, staticRenderFns } from "./allowanceSummaryInput.vue?vue&type=template&id=ab1c5a1c&scoped=true"
import script from "./allowanceSummaryInput.vue?vue&type=script&lang=js"
export * from "./allowanceSummaryInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1c5a1c",
  null
  
)

export default component.exports